import React from 'react';
import PropTypes from 'prop-types';

import {getOffset, getScrollPos} from '~/src/utilities/helpers/dom';
import {classNames} from '~/src/utilities/helpers/css';

import css from './Infinity.module.scss';

class Infinity extends React.Component {
    onScroll = () => {
        var calculatedValue;
        const domNodeRef = this.domNodeRef.current;
        const scrollNode = this.props.scrollNode || window;
        if (this.props.type === 'vertical') {
            calculatedValue = getOffset(domNodeRef)[1] + domNodeRef.offsetHeight - getScrollPos(scrollNode)[1] - window.innerHeight;
        } else {
            calculatedValue = getOffset(domNodeRef)[0] + domNodeRef.offsetWidth - getScrollPos(scrollNode)[0] - window.innerWidth;
        }
        if (calculatedValue < this.props.scrollOffset) {
            this.removeEvents();
            this.props.loadFunction && this.props.loadFunction();
        }
    };

    observerCallback = (entries, self) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                self.unobserve(entry.target);
                this.props.loadFunction && this.props.loadFunction();
            }
        });
    };

    addEvents() {
        const scrollNode = this.props.scrollNode || window;
        scrollNode.addEventListener('scroll', this.onScroll);
        scrollNode.addEventListener('resize', this.onScroll);
    }

    removeEvents() {
        const scrollNode = this.props.scrollNode || window;
        scrollNode.removeEventListener('scroll', this.onScroll);
        scrollNode.removeEventListener('resize', this.onScroll);
    }

    /**
     * creates an array with entries from 0.00 to 1.00
     */
    createThresholdRange() {
        return Array(101)
            .fill()
            .map((value, index) => index / 100);
    }

    static defaultProps = {
        type: 'vertical',
        scrollOffset: 650
    };

    constructor(props) {
        super(props);
        this.domNodeRef = React.createRef();

        if (process.browser && window.IntersectionObserver) {
            const options = {
                root: props.scrollNode || null,
                rootMargin: props.scrollOffset + 'px',
                threshold: this.createThresholdRange()
            };
            this.observer = new IntersectionObserver(this.observerCallback, options);
        }
    }

    componentDidMount() {
        if (window.IntersectionObserver) {
            this.observer.observe(this.domNodeRef.current);
        } else {
            this.addEvents();
        }
    }

    componentDidUpdate() {
        if (window.IntersectionObserver) {
            this.observer.observe(this.domNodeRef.current);
        } else {
            this.addEvents();
        }
    }

    componentWillUnmount() {
        if (window.IntersectionObserver) {
            this.observer && this.observer.disconnect();
        } else {
            this.removeEvents();
        }
    }

    render() {
        const classes = classNames(css, 'infinity', this.props.type);

        return <div ref={this.domNodeRef} className={classes}></div>;
    }
}

if (process.env.NODE_ENV === 'development') {
    Infinity.propTypes = {
        type: PropTypes.string,
        scrollOffset: PropTypes.number,
        scrollNode: PropTypes.object,
        loadFunction: PropTypes.func
    };
}

export default Infinity;
